import {kp_copy_notice} from "./kp-helpers";

const message1 = `Hi [Insert Manager's Name],

As you know, we've been struggling with communicating the great results we're getting to our clients. Plus, with the major changes in Google Analytics lately, we need to step up our analytics skills.

I've found an online course that not only covers the changes in GA4, but offers a comprehensive curriculum on selling and delivering analytics projects to our clients, plus building and implementing an effective analytics system. This course will equip our team with a much stronger analytics foundation and help us better serve our clients with superior data and reporting.

The course is called Analytics for Agencies (https://kpplaybook.com/analytics-for-agencies/). The lessons include topics like:

 • Effective goal setting with clients
 • Creating custom reports and dashboards
 • Consent management, privacy laws and cookies
 • How to set up GA4 and Google Tag Manager (including templates we can use right away)
 • Pre-built and client-tested Looker Studio dashboards that are ready to use at your agency

The course was created by an agency, for agencies, and will help us streamline our approach to analytics, provide our team with effective training, and give us the skills needed to plan, set up, analyze and optimize data-driven marketing strategies for our clients.

The instructor is Dana DiTomaso, and you might remember seeing her at MozCon (or whatever conference your team recently attended!). She's been working in the industry for 20+ years and worked with several hundred clients, at multiple agencies. I trust her to help us get to where we need to be when it comes to analytics.

The training costs $979 USD per person, which is substantially less than most conference tickets. Plus, if we enroll our whole team there are automatic discounts available. In addition to the lessons, the course also includes production ready resources that we can implement in our analytics process, an online community and regular office hours to ask implementation questions, and a certification upon completion. 
 
Let me know if I can go ahead and enroll myself and/or the rest of the team in the Analytics for Agencies course (https://kpplaybook.com/analytics-for-agencies/). I would be happy to provide you with more information on the course, its curriculum, and additional benefits, or the course instructor, Dana DiTomaso, is also available to have a Zoom call with you to go over any questions you have. You can book that here (https://calendly.com/danaditomaso/analytics-for-agencies)! Thank you for your time and consideration. 

Best,

[Your Name]
[Your Position]
[Your Department]
[Your Company]
`

const message2 = `Hi [Insert Manager's Name],

As you know, we've been struggling to report on results since the switch to GA4 and we need to improve our analytics skills. 

I've found a Google Analytics course, Practical GA4 (https://kpplaybook.com/google-analytics-4-course/), that offers hands-on learning, real-world examples, and direct instructor support. Not only will we learn how to get valuable insights out of GA4, we will learn how to analyze our data. 

The course covers everything we are currently struggling with when it comes to analytics:

 • Mastering Analytics Basics: Understand and demystify core analytics concepts to build a strong foundation.
 • Harnessing GA4's Powerful Features: Learn how to expertly implement events, key event parameters, and conversions to measure and evaluate website and marketing performance.
 • Creating Custom Reports: Craft reports tailored to our business goals, and leverage GA4's advanced Explorations features for deeper insights.
 • Driving Better Decisions: Quickly answer critical business questions, assess results efficiently, and gain insights to identify successful strategies and areas for improvement.

The instructor is Dana DiTomaso, who has over 20 years of industry experience and has worked with hundreds of clients, and spoken on analytics and reporting at major marketing conferences. Her expertise will help us achieve our analytics goals.

The cost is $279 USD per person, which is substantially less than a ticket to a conference or a workshop. There is even a team discount if we get everyone on board. The course includes lifetime access, templates, resources, a private online community where we can ask implementation questions, and a certification upon completion. 
 
Let me know if I can go ahead and enroll myself and/or the rest of the team in the Practical GA4 course (https://kpplaybook.com/google-analytics-4-course/).

Best,
[Your Name]
[Your Position]
[Your Department]
[Your Company]
`

const boss_links = document.querySelectorAll('a[href="#email-boss"]')
boss_links.forEach(link => {
    link.addEventListener('click', e => {
        e.preventDefault();
        navigator.clipboard.writeText(message1).then(() => {
            kp_copy_notice(link)
        });
    })
})

const boss_links_analytics = document.querySelectorAll('a[href="#email-boss-training"]')
boss_links_analytics.forEach(link => {
    link.addEventListener('click', e => {
        e.preventDefault();
        navigator.clipboard.writeText(message2).then(() => {
            kp_copy_notice(link)
        });
    })
})